const CopyRight = () => (<p className="text-white">© 2022 DataScientest</p>)

export default CopyRight;